module.exports = __webpack_public_path__ + "static/cetmen-web-24a7677ad65a91c2ebb134e76821f87b.jpg";